import { gql } from 'graphql.macro';

export const UpdateSheqManager = gql`
  mutation updateSheqManager($request: SHEQManagerCollectionUpdateRequestModelInput!) {
    updateSHEQManager(request: $request)
  }
`;